import React from 'react';

const ProcessComp = ({icon,stepIcon, step}) => {
  return (
    <div className='p-10 flex flex-col  justify-between items-start bg-white max-w-[330px] gap-[60px] rounded-3xl shadow-md'>
      <div>{icon}</div>
      <div className='flex flex-col gap-2.5'>
        <div>{stepIcon}</div>
        <div className='heading-24'>{step}</div>
      </div>

    </div>
  )
}

export default ProcessComp